<div class="wrapper clearfix" id="directorynav">
    <div class="ac_sitemenu">サイトメニュー</div>
    <div class="ac_sitemenu_box">
        <div class="menulist">
            <h3 class="mds_link">
                <a href="https://yamatoji.nara-kankou.or.jp/welcome/"
                    >ようこそ奈良へ</a
                >
            </h3>
            <h3 class="mds_link">
                <a href="https://yamatoji.nara-kankou.or.jp/access/"
                    >奈良へのアクセス</a
                >
            </h3>
            <h3 class="mds_link">
                <a
                    href="https://yamatoji.nara-kankou.or.jp/015guidebook_indivudual/"
                    >観光ガイドブック</a
                >
            </h3>
            <h3 class="mds_link">
                <a
                    href="http://yamatoji.nara-kankou.or.jp/024guidebook_business/?keyword=ml1n84yfrj"
                    >修学旅行ガイドブック</a
                >
            </h3>
            <h3 class="mds_link">
                <a href="https://yamatoji.nara-kankou.or.jp/app/"
                    >奈良県観光公式アプリ</a
                >
            </h3>
        </div>
        <div class="menulist">
            <h3 class="mds_link">
                <a href="https://yamatoji.nara-kankou.or.jp/001shaji/"
                    >神社・仏閣</a
                >
            </h3>
            <h3 class="mds_link">
                <a href="https://yamatoji.nara-kankou.or.jp/002kanko/">観光</a>
            </h3>
            <h3 class="mds_link">
                <a href="https://yamatoji.nara-kankou.or.jp/003events/"
                    >イベント・体験</a
                >
            </h3>
            <h3 class="mds_link">
                <a href="https://yamatoji.nara-kankou.or.jp/023flower_spot/"
                    >花</a
                >
            </h3>
            <h3 class="mds_link">
                <a href="https://yamatoji.nara-kankou.or.jp/006course/"
                    >モデルコース</a
                >
            </h3>
            <h3 class="mds_link">
                <a href="https://yamatoji.nara-kankou.or.jp/004shop/"
                    >グルメ・買う</a
                >
            </h3>
            <h3 class="mds_link">
                <a href="https://yamatoji.nara-kankou.or.jp/005onsen-yado/"
                    >温泉・宿泊</a
                >
            </h3>
        </div>
        <div class="menulist">
            <h3 class="mds_link">
                <a href="https://yamatoji.nara-kankou.or.jp/topics/">お知らせ</a
                >
            </h3>
            <h3 class="mds_link">
                <a href="https://yamatoji.nara-kankou.or.jp/business/"
                    >法人の方へ</a
                >
            </h3>
            <ul class="direct_link">
                <li>
                    <a
                        href="https://yamatoji.nara-kankou.or.jp/018img_delivery_user/"
                        >ストックフォトライブラリー</a
                    >
                </li>
                <li>
                    <a href="https://yamatoji.nara-kankou.or.jp/019film_c-nara/"
                        >フィルムコミッション</a
                    >
                </li>
                <li>
                    <a href="https://yamatoji.nara-kankou.or.jp/020movie/"
                        >奈良にゆかりの映画情報</a
                    >
                </li>
            </ul>
        </div>
        <div class="menulist">
            <h3 class="mds_link">
                <a href="javascript:void(0);" style="cursor: default;"
                    >おすすめリンク</a
                >
            </h3>
            <ul class="direct_link">
                <li>
                    <a href="https://yamatoji.nara-kankou.or.jp/008world/"
                        >奈良大和路の世界遺産</a
                    >
                </li>
                <li>
                    <a href="https://yamatoji.nara-kankou.or.jp/season/"
                        >四季のおすすめスポット</a
                    >
                </li>
                <li>
                    <a href="https://yamatoji.nara-kankou.or.jp/014toiawase/"
                        >観光についてのお問合わせ先</a
                    >
                </li>
                <li>
                    <a href="https://yamatoji.nara-kankou.or.jp/013kouyo/"
                        >奈良大和路からの紅葉だより</a
                    >
                </li>
                <li>
                    <a href="https://yamatoji.nara-kankou.or.jp/012sakura/"
                        >奈良大和路からの桜だより</a
                    >
                </li>
                <li>
                    <a href="https://yamatoji.nara-kankou.or.jp/011wedding/"
                        >あをによし奈良　和婚</a
                    >
                </li>
            </ul>
        </div>
    </div>
</div>
<div class="wrapper">
    <aside id="bnr">
        <ul class="clearfix">
            <li>
                <a href="http://fanclub.nara-kankou.or.jp/" target="_blank">
                    <img
                        src="https://yamatoji.nara-kankou.or.jp/img/bnr/bnr_FC_2022.jpg"
                        alt="奈良ファン倶楽部"
                        style="opacity: 1;"
                    />
                </a>
            </li>
            <li>
                <a href="http://yamatoji.nara-kankou.or.jp/app/">
                    <img
                        src="https://yamatoji.nara-kankou.or.jp/img/bnr/bnr_app.jpg"
                        alt="奈良県観光公式アプリ"
                        style="opacity: 1;"
                    />
                </a>
            </li>
        </ul>
    </aside>
</div>
<ul class="linklist">
    <li>
        <a href="https://yamatoji.nara-kankou.or.jp/sitemap.html"
            >サイトマップ</a
        >
    </li>
    <li>
        <a href="https://yamatoji.nara-kankou.or.jp/privacy.html"
            >サイトポリシー</a
        >
    </li>
    <li>
        <a href="https://yamatoji.nara-kankou.or.jp/link_banner.html"
            >リンクについて</a
        >
    </li>
    <li>
        <a href="http://www.nara-kankou.or.jp/" target="_blank"
            >一般財団法人 奈良県ビジターズビューロー</a
        >
    </li>
</ul>
<div id="sitelogo_footer">
    <a href="http://www.nara-kankou.or.jp/" target="_blank">
        <img
            src="https://yamatoji.nara-kankou.or.jp/img/common/sitelogo.png"
            alt="一般財団法人 奈良県ビジターズビューロー"
        />
    </a>
    <p>(C) Nara visitors Bureau, All Rights Reserved.</p>
</div>
